import { Or2NavTabs } from '../../components/navigation/Or2NavTabs';

export function HomeTabs() {
  const tabs = [
    {
      name: 'News',
      activePath: '/news',
      path: '/news',
      props: {},
    },
    {
      name: 'More',
      activePath: '/more',
      path: '/more',
      props: {},
    },
  ];

  return <Or2NavTabs tabs={tabs} />;
}
